import { Button } from "@material-ui/core";
import React from "react";
import { ListButton, SaveButton, Toolbar } from "react-admin";
import "./index.css";
const CustomButton = props => <Button  variant="contained" color="primary" label="My Custom Button" {...props} />

const ToolbarCustomButton = ({
    handleSubmit,
    handleSubmitWithRedirect,
    onSave,
    invalid,
    pristine,
    saving,
    submitOnEnter,
    ...rest
  }) => <CustomButton {...rest} />;

const SimpleFormToolbar = (props) => {
  const location = props.location.pathname.split('/')
    const path = location[location.length - 1]
  return (
    <Toolbar {...props} id="customFormToolBarWrapper">
      <SaveButton onSave={props.onSuccess} className="save-button" icon={<></>}/>
      <ListButton className="customFormCancelButton" label="Cancel" icon={<></>}>
        <div>Cancel</div>
      </ListButton>
    </Toolbar>
  );
};
export default SimpleFormToolbar;


